/**
 * The two bell tabs (CO-768).
 *
 * ⚠️ What used to live here — the type→tab map, `categoryOf` and `belongsToCategory` — is GONE
 * (EL-2463). The feed returns `category` on every row and filters by it, so a client copy of
 * that classification is now a second source of truth that can only drift from Brooklyn's. The
 * adapter lowercases the enum onto these values.
 *
 * These constants stay because they are the tab keys, the `?tab=` URL param, the side-nav link
 * targets and the Redux slice paths — none of which the server names.
 *
 * @module services/notifications/notificationCategory
 */

/** The `?category=` values Brooklyn accepts, and the tab keys the page uses. */
export const CATEGORIES = Object.freeze({
  CONTENT: 'content',
  COMMUNITY: 'community',
})

export default CATEGORIES
